<template>
  <div class="introduction_body">
    <div>
      <el-row style="margin: 0px">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
          <div class="grid-content bg-purple"></div>
          <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
              <div class="grid-content bg-purple"></div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 210px;
                    background-color: white;
                    height: 80px;
                    border-radius: 15px;
                    padding-top: 10px;
                  "
                >
                  <el-menu
                    :default-active="activeIndex"
                    class="el-menu-vertical-demo"
                    @select="handleOpen"
                  >
                    <el-menu-item index="1">
                      <i class="el-icon-user-solid"></i>
                      <span slot="title">教学服务团队</span>
                    </el-menu-item>
                    <!-- <el-menu-item index="2">
                      <i class="el-icon-user"></i>
                      <span slot="title">其他成员</span>
                    </el-menu-item> -->
                  </el-menu>
                </div>
              </div>
            </el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
              <div class="grid-content bg-purple-light"></div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 1000px;
                "
              >
                <div class="content_text_body">
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      padding-top: 10px;
                      border-bottom: 2px solid #0e64d9;
                      height: 60px;
                    "
                  >
                    <div
                      style="
                        font-size: 25px;
                        color: #0e64d9;
                        text-align: left;
                        line-height: 50px;
                        padding-left: 20px;
                      "
                    >
                      教学服务团队
                    </div>
                  </div>

                  <div class="content_text_m">
                    <div class="knowledge_text">
                      <div
                        class="chunk_item"
                        v-for="(item, index) in teamDatas"
                        :key="index"
                      >
                        <div class="chunk_head">
                          <div class="head_portrait">
                            <img width="60" :src="item.portrait" />
                          </div>
                          <div class="head_info">
                            <div class="info_name">
                              {{ item.name }} · {{ item.institution }}
                            </div>
                            <div class="info_appellation">
                              {{ item.appellation }}
                            </div>
                          </div>
                        </div>
                        <div class="chunk_content">{{ item.content }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- <div v-if="this.activeIndex === '1'">
                    <div class="content_text_m">
                      <el-table
                        :data="tableDataTeach"
                        border
                        style="width: 100%"
                      >
                        <el-table-column prop="num" label="序号" width="50">
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" width="80">
                        </el-table-column>
                        <el-table-column
                          prop="birthday"
                          label="出生年月"
                          width="80"
                        >
                        </el-table-column>
                        <el-table-column prop="unit" label="单位" width="160">
                        </el-table-column>
                        <el-table-column prop="job" label="职务" width="80">
                        </el-table-column>
                        <el-table-column
                          prop="jobTitle"
                          label="职称"
                          width="100"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="phone"
                          label="手机号码"
                          width="120"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="email"
                          label="电子邮箱"
                          width="190"
                        >
                        </el-table-column>
                        <el-table-column prop="task" label="承担任务">
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '2'">
                    <div class="content_text_m">
                      <el-table
                        :data="tableDatAmake"
                        border
                        style="width: 100%"
                      >
                        <el-table-column prop="num" label="序号" width="50">
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" width="80">
                        </el-table-column>
                        <el-table-column
                          prop="birthday"
                          label="出生年月"
                          width="80"
                        >
                        </el-table-column>
                        <el-table-column prop="unit" label="单位" width="220">
                        </el-table-column>
                        <el-table-column prop="job" label="职务" width="120">
                        </el-table-column>
                        <el-table-column
                          prop="jobTitle"
                          label="职称"
                          width="150"
                        >
                        </el-table-column>
                        <el-table-column prop="task" label="承担任务">
                        </el-table-column>
                      </el-table>
                    </div>
                  </div> -->
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Introduction",
  data () {
    return {
      activeIndex: "1",
      buttonType1: "",
      buttonType2: "",
      buttonType3: "",
      buttonType4: "",
      buttonIndex: "",
      teamDatas: [{
        portrait: require('@/assets/portrait/qianjianhua.jpg'),
        name: '钱建华',
        institution: '辽宁石油化工大学',
        appellation: '校长',
        content: '钱建华，男，1964年11月生，二级教授，国务院“政府特殊津贴”获得者，辽宁省特聘教授，博士生导师。现任辽宁石油化工大学校长，辽宁省石化产业技术创新研究院院长，辽宁省石化产业重点研究基地主任。《聚乙烯合成3D虚拟仿真实验》课程负责人，负责课程的总体设计与规划。教学方面，兼任教育部化学类教指委委员、辽宁省化学类教指委副主任委员、辽宁省学科评议组委员、第五届省政府督学。主讲《有机化学》和《高聚物合成工艺学》等课程，《有机化学》获批辽宁省一流本科课程；指导博士研究生7名，硕士研究生40余名；获辽宁省研究生教学成果特等奖1项、二等奖1项，辽宁省本科生教学成果一等奖2项，中国化工教育协会教学成果一等奖1项。科研方面，主要从事化工新材料技术、石化产业战略规划与布局、智能石化建设等方面的研究工作。兼任辽宁省化工学会副理事长、辽宁省石油石化学会副理事长等职务。主持国家自然科学基金面上项目2项，科技部科技人员服务中小企业项目、科技部中小企业创新基金及教育部重点研究项目4项，军工项目3项，中石化、中科炼化、中石油项目4项，辽宁省“揭榜挂帅”科技攻关专项1项，其他省级项目16项。获中国人民解放军军队科技进步三等奖1项、中国化工学会科学技术奖基础研究成果二等奖1项，辽宁省科技进步三等奖3项，市厅级科技进步一等奖6项、二等奖1项。授权发明专利20余件，颁布1项中国人民解放军军用标准。出版学术著作4部，在国内外重要学术期刊上发表论文150余篇，SCI、EI收录70余篇。'
      }, {
        portrait: require('@/assets/portrait/huyuexin.jpg'),
        name: '胡跃鑫',
        institution: '辽宁石油化工大学',
        appellation: '副院长',
        content: '胡跃鑫，男，1981年2月生，教授，硕士生导师，现任辽宁石油化工大学石油化工学院副院长、辽宁省化工学会橡胶专委会副主任委员、辽宁省化工学会石油化工专委会委员。《聚乙烯合成3D虚拟仿真实验》主要参与人员，负责课程内容设计、教学方法改革及推广。在教学方面，主讲《高分子物理》、《聚合物共混改性》、《高分物理实验》、《高分子材料与工程专业实验》和《生产实习》等课程。高分子材料与工程专业国家级一流本科专业建设点负责人，主持辽宁省质量工程项目2项，参与4项；主持省级教改项目2项，参与国家级教改项目1项，省级教改项目3项；荣获省级教学成果奖一等奖4项、二等奖2项和三等奖3项。在科研方面，主要从事高分子材料结构与性能方面的研究工作。主持省级科研项目3项，横向项目4项，参与国家级项目2项，省级科研项目4项，发表论文40余篇。'
      }, {
        portrait: require('@/assets/portrait/xulingzi.jpg'),
        name: '许凌子',
        institution: '石油化工学院',
        appellation: '实验教师',
        content: '许凌子，女，1982年生，实验师，现任辽宁石油化工大学石油化工实验教学中心教师。《聚乙烯合成3D虚拟仿真实验》主要参与人员，负责虚拟仿真软件的使用及培训。从事材料类专业实验教学多年。主讲《高分子化学实验》和《高分子材料成型工艺实验》等课程。参与建设国家级虚拟仿真类一流课程2项，省级虚拟仿真类一流课程1项，具备丰富的虚拟仿真项目建设和教学经验。在科研方面主要从事化工材料等方面的研究工作。主持横向项目1项，在学术期刊上发表论文10余篇，参与发表授权发明专利1件。'
      }, {
        portrait: require('@/assets/portrait/hanxiangyan.jpg'),
        name: '韩向艳',
        institution: '辽宁石油化工大学',
        appellation: '教师',
        content: '韩向艳，女，1978年10月生，副教授，现任辽宁石油化工大学高分子材料与工程系教师。《聚乙烯合成3D虚拟仿真实验》主要参与人员，负责聚乙烯合成工艺设计方案及流程模拟。教学方面，主讲《高分子化学》和《高分子材料成型加工原理》2门理论课程，同时承担《高分子物理实验》，《高分子材料与工程专业实验》、《专业课程设计》和《生产实习》等实验实践教学任务。《高分子化学》和《高分子材料成型加工原理》两门课程均获批省级一流本科课程。同时《高分子化学》课程获批校级教学案例库建设和课程思政示范课程。获批辽宁省普通高等教育本科教学改革研究项目2项，校级1项，参与校级教改项目3项。参与出版《材料化学》教材1部。指导大学生创新创业训练计划项目获国家级2项、省级2项，校级2项。指导大学生参加挑战杯、创新创业年会等竞赛，获省级二等奖2项，指导高分子材料创新创业大赛获国家级三等奖1项。获全国高校混合式教学设计创新大赛优秀奖，辽宁省普通高校教师教学大赛三等奖，辽宁省教育教学信息化大赛三等奖。校级教学创新大赛课件大赛一等奖，讲课比赛三等奖，微课大赛三等奖，课程思政大赛三等奖，辽宁省教学成果奖三等奖。科研方面，主持科研项目4项，其中省部级项目1项，横向项目3项，参与科研项目4项，其中国家级项目2项；获得抚顺市自然科学学术成果奖三等奖1项；在国内外重要学术期刊发表学术论文20余篇。'
      }, {
        portrait: require('@/assets/portrait/jichengcheng.jpg'),
        name: '季程程',
        institution: '辽宁石油化工大学',
        appellation: '实验师',
        content: '季程程，女，1987年生，实验师，现任辽宁石油化工大学石油化工产业链实训培训基地教师。《聚乙烯合成3D虚拟仿真实验》主要参与人员，负责学生现场实习及虚拟仿真软件技术服务。在教学方面，参与省级教改项目 1 项，校级教改项目 1 项，出版生产实践教材 1 部。2023 年，主持撰写的授课类案例荣获辽宁省教育教学信息化交流比赛省级三等奖，参与撰写的“混合式教学在化工类专业基地实践课程应用”获得了我校第三届教师教学创新大赛一等奖。所在的“石油化工与智能制造教学团队”获批 2023 年全国石油和化工教育优秀教学团队。在科研方面，主持横向课题1项，参与中石化、中石油项目5项，在国内外重要期刊发表论文10余篇。'
      }],
      tableDataTeach: [/* 
        {
          num: "1",
          name: "侯进慧",
          birthday: "1980.02",
          unit: "食品与生物工程学院",
          job: "副院长",
          jobTitle: "副教授",
          phone: "15152468732",
          email: "houjinhui0@126.com",
          task: "项目总体规划实施",
        },
        {
          num: "2",
          name: "李璐璐",
          birthday: "1989.02",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "讲师",
          phone: "15850510928",
          email: "luna310@xzit.edu.cn",
          task: "工艺设计、实验教学",
        },
        {
          num: "3",
          name: "范晓博",
          birthday: "1984.09",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "讲师",
          phone: "13151984928",
          email: "fanxiaobo@xzit.edu.cn",
          task: "工艺设计、实验教学",
        },
        {
          num: "4",
          name: "王哲",
          birthday: "1988.11",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "讲师",
          phone: "18220535129",
          email: "wangzhe2012@lzu.edu.cn",
          task: "教学内容设计",
        },
        {
          num: "5",
          name: "陈尚龙",
          birthday: "1982.10",
          unit: "食品与生物工程学院",
          job: "主任",
          jobTitle: "高级实验师",
          phone: "13641533169",
          email: "csl@xzit.edu.cn",
          task: "实验教学",
        },
      ],
      tableDatAmake: [
        {
          num: "1",
          name: "曹泽虹",
          birthday: "1963.05",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "副教授",
          task: "在线教学服务",
        },
        {
          num: "2",
          name: "时培宁",
          birthday: "1983.02",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "实验师",
          task: "日常管理在线服务",
        },
        {
          num: "3",
          name: "巫永华",
          birthday: "1984.06",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "讲师",
          task: "在线教学",
        },
        {
          num: "4",
          name: "师聪",
          birthday: "1990.02",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "实验师",
          task: "日常维护在线服务",
        },
        {
          num: "5",
          name: "张文莉",
          birthday: "1990.02",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "讲师",
          task: "模块更新在线服务",
        },
        {
          num: "6",
          name: "王颖",
          birthday: "1990.02",
          unit: "食品与生物工程学院",
          job: "无",
          jobTitle: "实验师",
          task: "网络管理在线服务",
        },
        {
          num: "7",
          name: "李枝院",
          birthday: "1974.09",
          unit: "山东图灵锶科技有限公司",
          job: "经理",
          jobTitle: "工程师",
          task: "技术开发与维护",
        },
        {
          num: "8",
          name: "马仲依",
          birthday: "1989.11",
          unit: "山东图灵锶科技有限公司",
          job: "项目经理",
          jobTitle: "工程师",
          task: "技术开发与维护",
        },
        {
          num: "9",
          name: "齐俊财",
          birthday: "2003.01",
          unit: "山东图灵锶科技有限公司",
          job: "网络部经理",
          jobTitle: "工程师",
          task: "技术开发与维护",
        }, */
      ],
    };
  },
  mounted () {
    this.cutpage("1");
  },
  methods: {
    cutpage (index) {
      this.buttonIndex = index;
      this.getbottontype();
    },
    getbottontype () {
      if (this.buttonIndex === "1") {
        this.buttonType1 = "primary";
        this.buttonType2 = "";
        this.buttonType3 = "";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "2") {
        this.buttonType1 = "";
        this.buttonType2 = "primary";
        this.buttonType3 = "";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "3") {
        this.buttonType1 = "";
        this.buttonType2 = "";
        this.buttonType3 = "primary";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "4") {
        this.buttonType1 = "";
        this.buttonType2 = "";
        this.buttonType3 = "";
        this.buttonType4 = "primary";
      }
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
    },
  },
};
</script>

<style  scoped>
.introduction_body {
  background: url('../../assets/banner/login.png');
}

.content_text_body {
  display: flex;
  background-color: white;
  height: auto;
  min-height: 605px;
  margin-bottom: 40px;
  border-radius: 15px;
  flex-direction: column;
  width: 100%;
}

.knowledge_text {
  width: 95%;
  margin: 20px auto;
  text-align: left;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.chunk_item {
  margin-bottom: 50px;
}

.chunk_head {
  display: flex;
}
.head_portrait {
  width: 60px;
  height: 60px;
  border-radius: 45px;
  object-fit: cover;
  overflow: hidden;
}

.head_info {
  margin-left: 20px;
}
.info_name {
  color: #2a2a2a;
  font-size: 16px;
  margin-bottom: 8px;
}
.info_appellation {
  color: #777;
  font-size: 14px;
  line-height: 25px;
}
.chunk_content {
  margin-top: 20px;
  color: #777;
  font-size: 16px;
  line-height: 25px;
}
</style>
